import React from "react";
import styled from "styled-components";
import { CompassParagraph } from "../../components/common/styledComponents";
import {
  Icon,
  IconContainer,
  LegendCircle,
} from "../../components/visuals/styledComponents";
import {
  ElementContainer,
  ColumnContainer,
} from "../../components/containers/styledComponents";
import { DecarbonisationPathwayChart } from "./DecarbonisationPathwayChart";
import arrow_icon from "../../assets/svg/arrow.svg";
import { CarbonPathwayByPortfolio } from "../../models/controlPanelDataModel";
import { darkGreen, graphPaletteV2 } from "../../styles";

const RotatedIconContainer = styled(IconContainer)`
  transform: rotate(90deg);
`;

const legends = [
  "Latest Year",
  "Decarbonisation Pathway",
  "Relative Decarbonisation (%)",
];
const legendColors = [graphPaletteV2[0], graphPaletteV2[2], graphPaletteV2[4]];

export const DecarbonisationPathwayCard: React.FC<
  DecarbonisationPathwayCardProps
> = ({ decarbonisationPathwayData }) => {
  const dataToDisplay = filterDataToDisplay(decarbonisationPathwayData);
  return (
    <>
      <CompassParagraph color={darkGreen} fontSize={16} bold={true}>
        Decarbonisation Pathway
      </CompassParagraph>
      <ElementContainer ai="center">
        <RotatedIconContainer size={30}>
          <Icon src={arrow_icon} />
        </RotatedIconContainer>
        <CompassParagraph ml={-10} color="#8B909A">
          2.1% vs last year
        </CompassParagraph>
      </ElementContainer>
      <DecarbonisationPathwayChart decarbonisationPathwayData={dataToDisplay} />
      <ColumnContainer mt={-10} jc="flex-start" ai="flex-start" ml={25}>
        {legends.map((data, index) => (
          <ElementContainer key={index} mb={8}>
            <LegendCircle color={legendColors[index]}></LegendCircle>
            <CompassParagraph color="#8B909A" fontSize={12}>
              {data}
            </CompassParagraph>
          </ElementContainer>
        ))}
      </ColumnContainer>
    </>
  );
};

const filterDataToDisplay = (
  allYearsData: CarbonPathwayByPortfolio[],
): CarbonPathwayByPortfolio[] => {
  const filteredData = allYearsData.filter(
    (data) =>
      data.year <= (allYearsData[0].year + 10 || 2035) || data.year % 2 === 0,
  );

  return filteredData;
};

type DecarbonisationPathwayCardProps = {
  decarbonisationPathwayData: CarbonPathwayByPortfolio[];
};
